var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 766,
    height: 806,
    viewBox: "0 0 766 806",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M625.962 290.066L766 272.149L635.075 186.644L446.341 245.515L538.266 362.288L241.788 76.8574L-350 0L91.9824 308.537L-99.157 197.574L-228.843 188.373L196.737 394.595H224.147L81.6308 806L262.491 579.509L171.806 606.074L579.672 421.159L627.202 219.573L625.962 290.066Z",
    fill: "#33B9EA",
    fillOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerLogo);
export default __webpack_public_path__ + "static/media/drawerLogo.fbb2f73aeac5b1e5cdc310430509f7d2.svg";
export { ForwardRef as ReactComponent };